import { EditIcon } from "@chakra-ui/icons";
import { IconButton, Input, InputGroup, InputRightElement, useDisclosure } from "@chakra-ui/react";
import { FC } from "react";

import { listToString } from "@nens/shared-utils";

import { SaveSchematisationDataType } from "../management/schematisations/SchematisationsDetail";
import { SaveSimulationDataType } from "../management/simulations/SimulationDetail";

import { EditTags } from "./EditTags";

type ShowTagsPropsBase = {
  tags: string[] | null | undefined;
  isEditable?: false;
};

interface ShowTagsEditable extends Omit<ShowTagsPropsBase, "isEditable"> {
  isEditable: true;
  saveData: SaveSchematisationDataType | SaveSimulationDataType;
  title?: string;
}

export type ShowTagsProps = ShowTagsPropsBase | ShowTagsEditable;

const ShowTags: FC<ShowTagsProps> = (props) => {
  const { tags, isEditable } = props;
  const visibleTags: string[] = (tags || []).filter((tag) => !hideTag(tag));

  const content = visibleTags.length > 0 ? listToString(visibleTags) : "-";
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!isEditable) return content;

  return (
    <>
      <InputGroup>
        <Input
          backgroundColor="brand.grey.100"
          borderWidth="base"
          borderStyle="solid"
          borderColor="brand.glacier"
          rounded={1}
          p={4}
          id="tags-field"
          value={content}
          readOnly
          _readOnly={{
            backgroundColor: "white",
          }}
        />
        {isEditable && (
          <InputRightElement>
            <IconButton
              icon={<EditIcon />}
              color="brand.analytic"
              aria-label="Edit tags"
              onClick={onOpen}
              size="sm"
              variant="ghost"
            />
          </InputRightElement>
        )}
      </InputGroup>
      {isEditable && (
        <EditTags
          title={props.title}
          isOpen={isOpen}
          onClose={onClose}
          tags={visibleTags}
          saveData={props.saveData}
        />
      )}
    </>
  );
};

function hideTag(tag: string): boolean {
  return !tag || tag.startsWith("API-") || tag.startsWith("core-") || tag.startsWith("framework-");
}

export default ShowTags;
